import { render } from "./DetalleRegistroModal.vue?vue&type=template&id=302292b6&scoped=true"
import script from "./DetalleRegistroModal.vue?vue&type=script&lang=js"
export * from "./DetalleRegistroModal.vue?vue&type=script&lang=js"

import "./DetalleRegistroModal.vue?vue&type=style&index=0&id=302292b6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-302292b6"]])

export default __exports__